import { Container, OldHeading, Image, SpecialSpan, OldText } from '@gassan-ui'
import { cn } from '@lib/cn'
import { getAspectRatioImage } from '@lib/get-image-aspect-ratio'
import { getKontentImage } from '@lib/kontent'
import { TudorCheckerboardItem } from '@lib/kontent/models/TudorCheckerboardItem'
import { FC } from 'react'

type TudorLandingPageCheckerboardProps = {
  items: TudorCheckerboardItem[]
}

export const TudorLandingPageCheckerboard: FC<TudorLandingPageCheckerboardProps> = ({ items }) => {
  if (items.length === 0) return null

  return (
    <Container maxWidth="1024px" className="mb-16 md:mb-24">
      {items.map((item, index) => {
        if (!item.image.value[0]) return null

        return (
          <div key={index} className="mb-8 grid md:mb-0 md:grid-cols-2 md:gap-0">
            <div
              className={cn(
                'flex flex-col gap-0 md:justify-center md:gap-4 md:px-8 lg:px-12',
                index % 2 === 0 ? 'md:text-right' : 'md:col-start-2 md:row-span-1',
              )}
            >
              <SpecialSpan variant="two" as="h6" color="tudorRed" mb="0">
                {item.pretitle.value}
              </SpecialSpan>
              <OldHeading variant="h2" as="h2" color="tudorText" mb="0" className="!leading-10">
                {item.title.value}
              </OldHeading>
              <OldText variant="small" color="tudorText" className="whitespace-pre-line">
                {item.description.value}
              </OldText>
            </div>
            <Image
              style={{ aspectRatio: getAspectRatioImage(item.image) }}
              sources={[
                getKontentImage(item.image.value[0].url, { width: 768 }),
                getKontentImage(item.image.value[0].url, { width: 768 }),
                getKontentImage(item.image.value[0].url, { width: 1200 }),
                getKontentImage(item.image.value[0].url, { width: 2000 }),
                getKontentImage(item.image.value[0].url, { width: 2500 }),
              ]}
              placeholderSrc={getKontentImage(item.image.value[0].url, { width: 20 })}
              alt={item.image.value[0].description as string}
              className={cn(index % 2 === 0 ? 'text-right' : 'md:col-start-1 md:row-start-1')}
            />
          </div>
        )
      })}
    </Container>
  )
}
